// Use the paid base plan consistently for both display and checkout on Play.
// An introductory offer must never be selected just because it is first.
export function getPaidBasePlan(product) {
  return product?.subscriptionOfferDetails?.find(offer => {
    const phases = offer?.pricingPhases?.pricingPhaseList;
    return !offer.offerId && !!offer.offerToken && phases?.length === 1
      && Number(phases[0].priceAmountMicros) > 0;
  }) || null;
}

export function getSubscriptionPrice(product, platform) {
  if (!product) return null;
  if (platform === 'android') {
    return getPaidBasePlan(product)?.pricingPhases?.pricingPhaseList?.[0]?.formattedPrice || null;
  }
  return product.localizedPrice || null;
}
